const module = { name: 'Fandango/amenityFlyout', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



const Selectors = {
    ANY_AMENITY_ICON: '.js-amenity',
    AD_TOP_BANNER: '#top-banner .ad-topbanner',
    FLYOUT_CONTAINER: '.js-flyout',
    FLYOUT_TITLE: '.js-flyout__title',
    FLYOUT_DESC: '.js-flyout__desc'
}
function onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const $this = $(this);
    const flyOutContainer = $(Selectors.FLYOUT_CONTAINER);
    $(Selectors.FLYOUT_TITLE).html($this.attr('data-amenity-name'));
    $(Selectors.FLYOUT_DESC).html($this.attr('data-amenity-desc'));
    const flyoutHeight = flyOutContainer.outerHeight();
    const parentOffsetLeft = ($this.offset().left - 30) + 'px';
    const parentOffsetTop = ($this.offset().top - flyoutHeight - 10) + 'px';
    flyOutContainer.css('left', parentOffsetLeft).css('top', parentOffsetTop).show();
}
function assignClickHandler($elm) {
    $elm.on('click', onClick);
}
function hideFlyout() {
    $(Selectors.FLYOUT_CONTAINER).hide();
}
function init() {
    assignClickHandler($(Selectors.ANY_AMENITY_ICON));
    $(document).on('click touchend', '.js-flyout__close, html', hideFlyout);
}
module.exports = {
    init
};
export default module.exports;